import { PropsWithChildren } from 'react';

export function InfrastructureWrapper({ children }: PropsWithChildren<{}>) {
  return <div data-testid="Infrastructure">{children}</div>;
}
